import React from 'react';
import { Link } from 'gatsby';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import BackgroundImg from 'gatsby-background-image';
import { LocalizedLink } from '../../components/language/localized-link';
import { WithIntl } from '../../components/language/with-intl.js';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { useTranslation } from 'react-i18next';

import Instagram from '../../assets/img/icons/social/instagram.inline.svg';
import Facebook from '../../assets/img/icons/social/facebook.inline.svg';
const Uniform = ({ language }) => {
    const data = useStaticQuery(graphql`
        query {
            header: file(relativePath: { eq: "uniform_header.jpeg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            section2: file(relativePath: { eq: "uniform-discussion.jpeg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);
    const { t } = useTranslation();

    return (
        <Layout>
            <SEO title={t('uniform.seo_title')} description={t('uniform.seo_description')} />
            <section className="mt-10 mb-5 mb-xl-15 pb-13">
                <div className="container col-12 header">
                    <div className="row align-items-stretch overflow-hidden mt-n10">
                        <div className="col-md-12 padding-uniform-cards">
                            <div className="card card-uniform-background-1">
                                <BackgroundImg fluid={data.header.childImageSharp.fluid} Tag="div" className="w-100 background-image-uniform-header">
                                    <div className="background-image-uniform" />
                                </BackgroundImg>
                            </div>
                            <div className="card card-uniform-background-2"></div>
                        </div>
                        <div className="col-12 offset-lg-1 text-center text-lg-left mt-uniform-title">
                            <h1 className="font-weight-bold text-white font-size-huge ml-n8" data-aos="fade-right">
                                <span className="font-weight-extra-bold">#</span>UniForm
                            </h1>
                        </div>
                        <div className="col-12 col-md-10 offset-md-1 col-lg-7 offset-lg-4 mt-14 mt-sm-15 mt-lg-10 text-center text-lg-right">
                            <h2 className="font-weight-medium text-secondary" data-aos="fade-left" data-aos-delay="200">
                                {t('uniform_description')}
                            </h2>
                            <a className="shadow shadow-lg" data-aos="fade-left" data-aos-delay="400">
                                <button className="btn btn-primary text-white btn-cta lift float-lg-right mt-5">{t('uniform.cta')}</button>
                            </a>
                        </div>
                        <div className="col-12 mt-10">
                            <a href="https://www.facebook.com/wesolvegr/" className="text-secondary mr-5" target="_blank" rel="noreferrer noopener">
                                <Facebook style={{ height: '60px', width: '60px' }} />
                            </a>
                            <a href="https://www.instagram.com/wesolve_gr/" className="text-secondary" target="_blank" rel="noreferrer noopener">
                                <Instagram style={{ height: '60px', width: '60px' }} />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mb-10 mb-md-15 pb-10 pb-md-15 w-100 overflow-hidden">
                <div className="container col-11 ml-auto">
                    <div className="row align-items-stretch">
                        <div className="col-12 col-lg-6 col-xl-6 text-left mt-xl-14">
                            <h2 className="display-3 font-weight-bold text-secondary" data-aos="fade-right" data-aos-delay="200">
                                {t('uniform.uniform-topics.heading')}
                            </h2>
                            <p className="lead mt-5 text-gray-800" data-aos="fade-right" data-aos-delay="400">
                                {t('uniform.uniform-topics.description')}
                            </p>
                            <div className="d-flex custom-numbered-list-item mt-10" data-aos="fade-right" data-aos-delay="600">
                                <div className="badge badge-lg badge-rounded-circle badge-primary-soft">
                                    <span>1</span>
                                </div>
                                <div className="ml-5">
                                    <p className="lead text-secondary mb-auto">{t('uniform.uniform-topics.topic-1')}</p>
                                </div>
                            </div>
                            <div className="d-flex custom-numbered-list-item" data-aos="fade-right" data-aos-delay="800">
                                <div className="badge badge-lg badge-rounded-circle badge-primary-soft">
                                    <span>2</span>
                                </div>
                                <div className="ml-5">
                                    <p className="lead text-secondary mb-auto">{t('uniform.uniform-topics.topic-2')}</p>
                                </div>
                            </div>
                            <div className="d-flex custom-numbered-list-item" data-aos="fade-right" data-aos-delay="1000">
                                <div className="badge badge-lg badge-rounded-circle badge-primary-soft">
                                    <span>3</span>
                                </div>
                                <div className="ml-5">
                                    <p className="lead text-secondary mb-auto">{t('uniform.uniform-topics.topic-3')}</p>
                                </div>
                            </div>
                            <div className="d-flex custom-numbered-list-item" data-aos="fade-right" data-aos-delay="1200">
                                <div className="badge badge-lg badge-rounded-circle badge-primary-soft">
                                    <span>4</span>
                                </div>
                                <div className="ml-5">
                                    <p className="lead text-secondary mb-auto">{t('uniform.uniform-topics.topic-4')}</p>
                                </div>
                            </div>
                            <div className="d-flex custom-numbered-list-item" data-aos="fade-right" data-aos-delay="1400">
                                <div className="badge badge-lg badge-rounded-circle badge-primary-soft">
                                    <span>5</span>
                                </div>
                                <div className="ml-5">
                                    <p className="lead text-secondary mb-auto">{t('uniform.uniform-topics.topic-5')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 pb-15 header mt-5 mt-lg-14 mb-15">
                            <div className="card card-uniform-background-3 mt-5">
                                <BackgroundImg fluid={data.section2.childImageSharp.fluid} Tag="div" className="w-100 background-image-uniform-2-container">
                                    <div className="background-image-uniform-2" />
                                </BackgroundImg>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-10 mb-md-15 pb-md-15">
                <div className="container col-11">
                    <div className="row align-items-stretch mt-md-n10 mb-xl-10">
                        <div className="col-12 col-xl-8 ml-auto mr-auto text-center mt-xl-n10">
                            <h2 className="display-2 font-weight-bold text-secondary">{t('uniform.steps.heading')}</h2>
                            <p className="lead text-gray-800 mt-6">{t('uniform.steps.subheading')}</p>
                        </div>
                    </div>
                    <div className="row align-items-stretch">
                        <div className="col-12 col-md-8 col-lg-6 order-2 pb-xl-10">
                            <div className="row mb-md-5 mb-10 text-center text-md-left mt-5 mt-md-0">
                                <svg
                                    className="ml-auto mr-auto mb-1 d-md-none"
                                    width="20vw"
                                    height="20vw"
                                    viewBox="0 0 200 200"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="1"
                                        d="M99.9994 183.334C146.023 183.334 183.333 146.024 183.333 100C183.333 53.9766 146.023 16.667 99.9994 16.667C53.9756 16.667 16.666 53.9766 16.666 100C16.666 146.024 53.9756 183.334 99.9994 183.334Z"
                                        fill="#FF6600"
                                    />
                                    <path
                                        d="M108.333 91.6663C108.333 87.064 104.602 83.333 99.9993 83.333C95.397 83.333 91.666 87.064 91.666 91.6663V133.333C91.666 137.935 95.397 141.666 99.9993 141.666C104.602 141.666 108.333 137.935 108.333 133.333V91.6663Z"
                                        fill="#FFF"
                                    />
                                    <path
                                        d="M108.333 66.6663C108.333 62.064 104.602 58.333 99.9993 58.333C95.397 58.333 91.666 62.064 91.666 66.6663C91.666 71.2687 95.397 74.9997 99.9993 74.9997C104.602 74.9997 108.333 71.2687 108.333 66.6663Z"
                                        fill="#FFF"
                                    />
                                </svg>
                                <div className="col-12">
                                    <h5 className="text-uppercase text-primary pt-1">{t('uniform.steps.partA_title')}</h5>
                                </div>
                                <div className="col-12">
                                    <h4 className="text-muted">{t('uniform.steps.partA_description')}</h4>
                                </div>
                            </div>
                            <div className="row mb-md-5 mb-10 text-center text-md-left">
                                <svg
                                    className="ml-auto mr-auto mb-1 d-md-none"
                                    width="20vw"
                                    height="20vw"
                                    viewBox="0 0 200 200"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="1"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M120.718 150L106.645 175.471C104.419 179.5 99.3495 180.961 95.3211 178.735C94.147 178.087 93.1468 177.164 92.4055 176.046L75.1371 150H41.666C27.8589 150 16.666 138.807 16.666 125V50C16.666 36.1929 27.8589 25 41.666 25H158.333C172.14 25 183.333 36.1929 183.333 50V125C183.333 138.807 172.14 150 158.333 150H120.718Z"
                                        fill="#FF6600"
                                    />
                                    <path
                                        opacity="1"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M49.9994 58.333H124.999C129.602 58.333 133.333 62.064 133.333 66.6663C133.333 71.2687 129.602 74.9997 124.999 74.9997H49.9994C45.397 74.9997 41.666 71.2687 41.666 66.6663C41.666 62.064 45.397 58.333 49.9994 58.333ZM49.9994 91.6663H91.666C96.2684 91.6663 99.9994 95.3973 99.9994 99.9997C99.9994 104.602 96.2684 108.333 91.666 108.333H49.9994C45.397 108.333 41.666 104.602 41.666 99.9997C41.666 95.3973 45.397 91.6663 49.9994 91.6663Z"
                                        fill="#FFF"
                                    />
                                </svg>
                                <div className="col-12">
                                    <h5 className="text-uppercase text-primary pt-1">{t('uniform.steps.partB_title')}</h5>
                                </div>
                                <div className="col-12">
                                    <h4 className="text-muted">{t('uniform.steps.partB_description.pt1')}</h4>
                                    <h4 className="text-muted">{t('uniform.steps.partB_description.pt2')}</h4>
                                    <h4 className="text-muted">{t('uniform.steps.partB_description.pt3')}</h4>
                                </div>
                            </div>
                            <div className="row mb-md-5 mb-10 text-center text-md-left">
                                <svg
                                    className="ml-auto mr-auto mb-1 d-md-none"
                                    width="20vw"
                                    height="20vw"
                                    viewBox="0 0 200 200"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="1"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M25 100C25 100 45.4545 50 100 50C140.909 50 175 100 175 100C175 100 140.909 150 100 150C45.4545 150 25 100 25 100Z"
                                        fill="#FF6600"
                                    />
                                    <path
                                        opacity="1"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M100 125C86.1929 125 75 113.807 75 100C75 86.1929 86.1929 75 100 75C113.807 75 125 86.1929 125 100C125 113.807 113.807 125 100 125Z"
                                        fill="#FFF"
                                    />
                                </svg>
                                <div className="col-12">
                                    <h5 className="text-uppercase text-primary pt-1">{t('uniform.steps.partC_title')}</h5>
                                </div>
                                <div className="col-12">
                                    <h4 className="text-muted">{t('uniform.steps.partC_description.pt1')}</h4>
                                    <h4 className="text-muted">{t('uniform.steps.partC_description.pt2')}</h4>
                                </div>
                            </div>
                            <div className="row mb-md-5 mb-10 text-center text-md-left">
                                <svg
                                    className="ml-auto mr-auto mb-1 d-md-none"
                                    width="20vw"
                                    height="20vw"
                                    viewBox="0 0 200 200"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M45.834 33.333H79.1673C86.0709 33.333 91.6673 38.9294 91.6673 45.833V54.1663C91.6673 61.0699 86.0709 66.6663 79.1673 66.6663H45.834C38.9304 66.6663 33.334 61.0699 33.334 54.1663V45.833C33.334 38.9294 38.9304 33.333 45.834 33.333ZM120.834 133.333H154.167C161.071 133.333 166.667 138.929 166.667 145.833V154.166C166.667 161.07 161.071 166.666 154.167 166.666H120.834C113.93 166.666 108.334 161.07 108.334 154.166V145.833C108.334 138.929 113.93 133.333 120.834 133.333Z"
                                        fill="#FF6600"
                                    />
                                    <path
                                        opacity="1"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M45.834 83.333H79.1673C86.0709 83.333 91.6673 88.9294 91.6673 95.833V154.166C91.6673 161.07 86.0709 166.666 79.1673 166.666H45.834C38.9304 166.666 33.334 161.07 33.334 154.166V95.833C33.334 88.9294 38.9304 83.333 45.834 83.333ZM120.834 33.333H154.167C161.071 33.333 166.667 38.9294 166.667 45.833V104.166C166.667 111.07 161.071 116.666 154.167 116.666H120.834C113.93 116.666 108.334 111.07 108.334 104.166V45.833C108.334 38.9294 113.93 33.333 120.834 33.333Z"
                                        fill="#336699"
                                    />
                                </svg>
                                <div className="col-12">
                                    <h5 className="text-uppercase text-primary pt-1">{t('uniform.steps.partD_title')}</h5>
                                </div>
                                <div className="col-12">
                                    <h4 className="text-muted">{t('uniform.steps.partD_description')}</h4>
                                </div>
                            </div>
                            <div className="row mb-md-5 mb-10 text-center text-md-left">
                                <svg
                                    className="ml-auto mr-auto circle bg-primary mb-4 d-md-none"
                                    width="18vw"
                                    height="18vw"
                                    viewBox="0 0 200 200"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M147.817 52.9361C150.798 49.4294 156.057 49.003 159.564 51.9837C163.07 54.9644 163.497 60.2235 160.516 63.7303L89.6827 147.064C86.6551 150.625 81.2906 151.001 77.7968 147.895L40.2968 114.562C36.8569 111.504 36.5471 106.237 39.6047 102.797C42.6624 99.357 47.9297 99.0471 51.3695 102.105L82.5016 129.778L147.817 52.9361Z"
                                        fill="#FFF"
                                    />
                                </svg>
                                <div className="col-12">
                                    <h5 className="text-uppercase text-primary pt-1">{t('uniform.steps.partE_title')}</h5>
                                </div>
                                <div className="col-12">
                                    <h4 className="text-muted">{t('uniform.steps.partE_description')}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-6 order-1 mt-13 d-none d-md-block">
                            <div className="scene cube-1 mt-xl-n10 ml-auto mr-auto">
                                <div className="cube isometric-1">
                                    <div className="cube__face cube__face--front"></div>
                                    <div className="cube__face cube__face--back"></div>
                                    <div className="cube__face cube__face--right"></div>
                                    <div className="cube__face cube__face--left"></div>
                                    <div className="cube__face_other cube__face--top">
                                        <svg className="circle" width="9vw" height="9vw" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                opacity="1"
                                                d="M99.9994 183.334C146.023 183.334 183.333 146.024 183.333 100C183.333 53.9766 146.023 16.667 99.9994 16.667C53.9756 16.667 16.666 53.9766 16.666 100C16.666 146.024 53.9756 183.334 99.9994 183.334Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                d="M108.333 91.6663C108.333 87.064 104.602 83.333 99.9993 83.333C95.397 83.333 91.666 87.064 91.666 91.6663V133.333C91.666 137.935 95.397 141.666 99.9993 141.666C104.602 141.666 108.333 137.935 108.333 133.333V91.6663Z"
                                                fill="#336699"
                                            />
                                            <path
                                                d="M108.333 66.6663C108.333 62.064 104.602 58.333 99.9993 58.333C95.397 58.333 91.666 62.064 91.666 66.6663C91.666 71.2687 95.397 74.9997 99.9993 74.9997C104.602 74.9997 108.333 71.2687 108.333 66.6663Z"
                                                fill="#336699"
                                            />
                                        </svg>
                                        <p className="cube_text">{t('uniform.steps.partA_title')}</p>
                                    </div>
                                    <div className="cube__face_other cube__face--bottom"></div>
                                </div>
                            </div>
                            <div className="scene cube-2 mt-n7 ml-auto mr-auto">
                                <div className="cube isometric-2">
                                    <div className="cube__face cube__face--front"></div>
                                    <div className="cube__face cube__face--back"></div>
                                    <div className="cube__face cube__face--right"></div>
                                    <div className="cube__face cube__face--left"></div>
                                    <div className="cube__face_other cube__face--top">
                                        <svg width="9vw" height="9vw" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                opacity="1"
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M120.718 150L106.645 175.471C104.419 179.5 99.3495 180.961 95.3211 178.735C94.147 178.087 93.1468 177.164 92.4055 176.046L75.1371 150H41.666C27.8589 150 16.666 138.807 16.666 125V50C16.666 36.1929 27.8589 25 41.666 25H158.333C172.14 25 183.333 36.1929 183.333 50V125C183.333 138.807 172.14 150 158.333 150H120.718Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                opacity="1"
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M49.9994 58.333H124.999C129.602 58.333 133.333 62.064 133.333 66.6663C133.333 71.2687 129.602 74.9997 124.999 74.9997H49.9994C45.397 74.9997 41.666 71.2687 41.666 66.6663C41.666 62.064 45.397 58.333 49.9994 58.333ZM49.9994 91.6663H91.666C96.2684 91.6663 99.9994 95.3973 99.9994 99.9997C99.9994 104.602 96.2684 108.333 91.666 108.333H49.9994C45.397 108.333 41.666 104.602 41.666 99.9997C41.666 95.3973 45.397 91.6663 49.9994 91.6663Z"
                                                fill="#336699"
                                            />
                                        </svg>
                                        <p className="cube_text">{t('uniform.steps.partB_title')}</p>
                                    </div>
                                    <div className="cube__face_other cube__face--bottom"></div>
                                </div>
                            </div>
                            <div className="scene cube-3 mt-n7 ml-auto mr-auto">
                                <div className="cube isometric-3">
                                    <div className="cube__face cube__face--front"></div>
                                    <div className="cube__face cube__face--back"></div>
                                    <div className="cube__face cube__face--right"></div>
                                    <div className="cube__face cube__face--left"></div>
                                    <div className="cube__face_other cube__face--top">
                                        <svg width="9vw" height="9vw" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                opacity="1"
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M25 100C25 100 45.4545 50 100 50C140.909 50 175 100 175 100C175 100 140.909 150 100 150C45.4545 150 25 100 25 100Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                opacity="1"
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M100 125C86.1929 125 75 113.807 75 100C75 86.1929 86.1929 75 100 75C113.807 75 125 86.1929 125 100C125 113.807 113.807 125 100 125Z"
                                                fill="#336699"
                                            />
                                        </svg>
                                        <p className="cube_text">{t('uniform.steps.partC_title')}</p>
                                    </div>
                                    <div className="cube__face_other cube__face--bottom"></div>
                                </div>
                            </div>
                            <div className="scene cube-4 mt-n7 ml-auto mr-auto">
                                <div className="cube isometric-4">
                                    <div className="cube__face cube__face--front"></div>
                                    <div className="cube__face cube__face--back"></div>
                                    <div className="cube__face cube__face--right"></div>
                                    <div className="cube__face cube__face--left"></div>
                                    <div className="cube__face_other cube__face--top">
                                        <svg width="9vw" height="9vw" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M45.834 33.333H79.1673C86.0709 33.333 91.6673 38.9294 91.6673 45.833V54.1663C91.6673 61.0699 86.0709 66.6663 79.1673 66.6663H45.834C38.9304 66.6663 33.334 61.0699 33.334 54.1663V45.833C33.334 38.9294 38.9304 33.333 45.834 33.333ZM120.834 133.333H154.167C161.071 133.333 166.667 138.929 166.667 145.833V154.166C166.667 161.07 161.071 166.666 154.167 166.666H120.834C113.93 166.666 108.334 161.07 108.334 154.166V145.833C108.334 138.929 113.93 133.333 120.834 133.333Z"
                                                fill="#FF6600"
                                            />
                                            <path
                                                opacity="1"
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M45.834 83.333H79.1673C86.0709 83.333 91.6673 88.9294 91.6673 95.833V154.166C91.6673 161.07 86.0709 166.666 79.1673 166.666H45.834C38.9304 166.666 33.334 161.07 33.334 154.166V95.833C33.334 88.9294 38.9304 83.333 45.834 83.333ZM120.834 33.333H154.167C161.071 33.333 166.667 38.9294 166.667 45.833V104.166C166.667 111.07 161.071 116.666 154.167 116.666H120.834C113.93 116.666 108.334 111.07 108.334 104.166V45.833C108.334 38.9294 113.93 33.333 120.834 33.333Z"
                                                fill="#FFFFFF"
                                            />
                                        </svg>
                                        <p className="cube_text">{t('uniform.steps.partD_title')}</p>
                                    </div>
                                    <div className="cube__face_other cube__face--bottom"></div>
                                </div>
                            </div>
                            <div className="scene cube-5 mt-n7 ml-auto mr-auto">
                                <div className="cube isometric-5">
                                    <div className="cube__face cube__face--front"></div>
                                    <div className="cube__face cube__face--back"></div>
                                    <div className="cube__face cube__face--right"></div>
                                    <div className="cube__face cube__face--left"></div>
                                    <div className="cube__face_other cube__face--top">
                                        <svg
                                            className="circle bg-white"
                                            width="8vw"
                                            height="8vw"
                                            viewBox="0 0 200 200"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M147.817 52.9361C150.798 49.4294 156.057 49.003 159.564 51.9837C163.07 54.9644 163.497 60.2235 160.516 63.7303L89.6827 147.064C86.6551 150.625 81.2906 151.001 77.7968 147.895L40.2968 114.562C36.8569 111.504 36.5471 106.237 39.6047 102.797C42.6624 99.357 47.9297 99.0471 51.3695 102.105L82.5016 129.778L147.817 52.9361Z"
                                                fill="#FF6600"
                                            />
                                        </svg>
                                        <p className="cube_text">{t('uniform.steps.partE_title')}</p>
                                    </div>
                                    <div className="cube__face_other cube__face--bottom"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape shape-bottom shape-fluid-x svg-shim">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="#F1F4F8" />
                    </svg>
                </div>
            </div>
        </Layout>
    );
};

export default WithIntl()(Uniform);
